<template>
  <div class="cat-external-dashboard externalDashboardContainer">
    <div class="grid-x grid-margin-x">
      <div class="small-12 cell">
        <slot name="notifications"></slot>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="small-12 cell">
        <h2 data-label-type="heading" class="h3 mtn mbs">
          <slot name="greeting"></slot>
        </h2>
        <slot name="greeting-notice"></slot>
      </div>

      <div v-if="betaAlert === 'beta'" class="small-12 cell">
        <cat-errors container html error-level="3"
          ><h5>Release information</h5>
          <p>
            You have access to sections in our demo site that are currently
            undergoing upgrades.
          </p>
          <p>
            When browsing, if upgrades are in use you will see a
            <span class="beta-icon">RELEASE INFO</span> tab on the left of the
            page.
          </p>
        </cat-errors>
      </div>

      <div :class="leftColumnSize + ' cell pbs'">
        <div class="main-content mn pn" style="height: 100%">
          <a name="main-content"></a>
          <slot name="left"></slot>
        </div>
      </div>
      <div :class="rightColumnSize + ' cell pbs'">
        <div class="dashboard-side-content borderedContainer">
          <slot name="right"></slot>
        </div>
        <div
          v-for="n in rightSlots - 1"
          :key="n"
          class="dashboard-side-content borderedContainer"
        >
          <slot :name="'right_' + (n + 1)"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatExternalDashboard",
  inject: ["addContentClass"],
  props: {
    id: {
      type: [String, Number]
    },
    heading: {
      type: [String]
    },
    errors: {
      type: [Array]
    },
    leftColumnSize: {
      type: [String],
      default: "small-12 mlarge-8",
      description: "Main content column class."
    },
    rightColumnSize: {
      type: [String],
      default: "small-12 mlarge-4 mlarge-push-8",
      description: "Side content column class."
    },
    betaAlert: {
      type: [String],
      default: "false",
      description: "Displays release information."
    },
    rightSlots: {
      type: [Number],
      default: 1,
      description: "Slot content for the side content."
    }
  },
  mounted: function () {
    if (this.addContentClass) {
      this.addContentClass("has-side-content");
    }
  }
});
</script>
